// This file can be copied to app.config.js
// App.config.js is ignored by git, and be different per system
//
// API url: direct link to the API to talk with
// Environment: development, production

module.exports = {
    api_url: 'https://api-crs.nibhv.nl',
    environment: 'production',
    sentry_key: 'e186793112694c168c48f64b00e798ba',
    sentry_app: '208439',
    sentry_env: 'production',
    google_analytics_id: 'UA-63941095-2',
    hotjar_id: '1595423',
    onboarding_state: 1,
    // set to false to disable a the "request passes" button:
    requestAdditionalPasses: true,
    filter_related_profiles: "server",
}
